import { THEME_COLOR } from "../../styles/colors";
import { SESSION_STATUS_MESSAGE } from "../../utils/rtmsSessionStatusUtils";

// Variant names for AlertModal. Use these instead of raw strings at call sites so typos are
// caught and editors can autocomplete. Add a new key here and a case in resolveVariant together.
export const ALERT_VARIANT = {
  COMMON_ERROR: "commonError",
  SERVER_NOT_RESPONDING: "serverNotResponding",
  AUTO_START_FAILED: "autoStartFailed",
  AIMS_TIMEOUT: "aimsTimeout",
  RTMS_ERROR: "rtmsError",
};

// Meridian Theme tokens for the modal shell (design data, not CSS) — the teal flat header.
export const ALERT_MODAL_THEME_TOKENS = {
  modalHeaderBackgroundColor: THEME_COLOR.LIGHT_TEAL,
  modalHeaderSpacingInsetTop: "0px",
  modalHeaderSpacingInsetBottom: "0px",
  modalHeaderFontSize: "8px",
  modalHeaderMinHeight: "8px",
  modalFooterBorderColor: THEME_COLOR.WHITE,
};

// RTMS error copy, keyed by context then error type. Titles render as h100, descriptions as b200.
export const RTMS_CONTENT = {
  summarize: {
    [SESSION_STATUS_MESSAGE.RTMS_INIT_ERROR]: {
      title: "Server not responding",
      description: `Click "Restart" to summarize this meeting.`,
      description2: `Restart meeting summary - up to 1 min.`,
    },
    [SESSION_STATUS_MESSAGE.RTMS_RUNTIME_ERROR]: {
      title: "Meeting summary stopped unexpectedly",
      description: `Click "Restart" to summarize this meeting.`,
      description2: `Restart meeting summary - up to 1 min.`,
      description3: `You'll receive a separate meeting summary.`,
    },
  },
  transcribe: {
    [SESSION_STATUS_MESSAGE.RTMS_INIT_ERROR]: {
      title: "Server not responding",
      title2: "Start taking notes",
      description: `Click "Restart" to transcribe this meeting.`,
      description2: `Restart meeting transcription - up to 1 min.`,
    },
    [SESSION_STATUS_MESSAGE.RTMS_RUNTIME_ERROR]: {
      title: "Meeting transcription stopped unexpectedly",
      description: `Click "Restart" to transcribe this meeting.`,
      description2: `Restart meeting transcription - up to 1 min.`,
    },
  },
};
